<!-- ============================================================ -->
<!-- MODAIS                                                       -->
<!-- ============================================================ -->
<ng-container *ngFor="let msg of messages">
  <div class="sv-message-overlay" [@overlayAnimation] (click)="onOverlayClick($event, msg)">
    <div class="sv-message-modal" [@modalAnimation] [style.transform]="getTranslate(msg)" [style.max-width]="msg.customMaxWidth">
      <!-- Header — barra de gradiente arrastável (sem texto nem cruz) -->
      <div class="sv-modal-header" (mousedown)="onDragStart($event, msg)" (touchstart)="onDragStart($event, msg)"></div>

      <!-- Corpo do modal -->
      <div class="sv-modal-body">
        <!-- Ícone PNG alertas (success/error/warning — SEMPRE usa PNG, ignora imageUrl) -->
        <div
          class="sv-icon-container sv-icon-png-container"
          *ngIf="msg.type === 'success' || msg.type === 'error' || msg.type === 'warning'"
          [@iconBounce]
        >
          <ng-container [ngSwitch]="msg.type">
            <img *ngSwitchCase="'success'" src="assets/alertas/sucess.png" class="sv-icon-png" alt="Sucesso" />
            <img *ngSwitchCase="'error'" src="assets/alertas/error.png" class="sv-icon-png" alt="Erro" />
            <img *ngSwitchCase="'warning'" src="assets/alertas/warning.png" class="sv-icon-png" alt="Aviso" />
          </ng-container>
        </div>

        <!-- Imagem personalizada (apenas para info/question — ex: logótipo) -->
        <div
          *ngIf="msg.imageUrl && msg.type !== 'success' && msg.type !== 'error' && msg.type !== 'warning'"
          class="sv-image-container"
          style="text-align: center; padding: 16px 0"
        >
          <img [src]="msg.imageUrl" [style.max-width.px]="msg.imageWidth || 120" alt="" style="display: inline-block" />
        </div>

        <!-- Texto / HTML -->
        <p *ngIf="msg.title" class="sv-message-title" [innerHTML]="msg.title"></p>
        <p *ngIf="msg.text" class="sv-message-text">{{ msg.text }}</p>
        <div *ngIf="msg.html" class="sv-message-html" [attr.data-msg-id]="messages.indexOf(msg)" #htmlContainer></div>

        <!-- Input de texto (quando input: 'text') -->
        <div *ngIf="msg.input === 'text'" class="sv-input-container">
          <input
            type="text"
            class="sv-input-text"
            [class.sv-input-error]="msg._inputValidationMessage"
            [(ngModel)]="msg._inputCurrentValue"
            [placeholder]="msg.inputPlaceholder || ''"
            (keydown.enter)="confirmModal(msg)"
            autofocus
          />
          <div *ngIf="msg._inputValidationMessage" class="sv-input-validation">
            {{ msg._inputValidationMessage }}
          </div>
        </div>
      </div>

      <!-- Botões -->
      <!-- Regra: Cancelar/Retroceder/Voltar → esquerda | Confirmar/Avançar/Seguinte/Validar → direita -->
      <div class="sv-modal-footer">
        <div class="sv-message-actions">
          <!-- Botão de cancelar — sempre à esquerda -->
          <button *ngIf="msg.showCancelButton" class="sv-btn sv-btn-cancel sv-btn-left" (click)="cancelModal(msg)">
            {{ msg.cancelButtonText || 'Não' }}
          </button>
          <!-- Botão de confirmar — sempre à direita -->
          <button
            *ngIf="msg.showConfirmButton !== false"
            class="sv-btn sv-btn-right"
            [ngClass]="getConfirmButtonClass(msg.type)"
            (click)="confirmModal(msg)"
          >
            {{ msg.confirmButtonText || 'OK' }}
          </button>
        </div>
      </div>
    </div>
  </div>
</ng-container>

<!-- ============================================================ -->
<!-- TOASTS                                                       -->
<!-- ============================================================ -->
<div class="sv-toast-container" *ngIf="toasts.length > 0">
  <ng-container *ngFor="let toast of toasts; trackBy: trackToastById">
    <div
      class="sv-toast"
      [ngClass]="'sv-toast-' + toast.type"
      [@toastAnimation]
      (click)="dismissToast(toast.id, false)"
    >
      <div class="sv-toast-icon">
        <ng-container [ngSwitch]="toast.type">
          <svg
            *ngSwitchCase="'success'"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          >
            <path d="M20 6L9 17l-5-5" />
          </svg>
          <svg
            *ngSwitchCase="'error'"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          >
            <line x1="18" y1="6" x2="6" y2="18" />
            <line x1="6" y1="6" x2="18" y2="18" />
          </svg>
          <svg
            *ngSwitchCase="'warning'"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          >
            <path d="M12 9v4m0 4h.01" />
            <path d="M10.29 3.86L1.82 18a2 2 0 001.71 3h16.94a2 2 0 001.71-3L13.71 3.86a2 2 0 00-3.42 0z" />
          </svg>
          <svg
            *ngSwitchCase="'info'"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          >
            <circle cx="12" cy="12" r="10" />
            <line x1="12" y1="16" x2="12" y2="12" />
            <line x1="12" y1="8" x2="12.01" y2="8" />
          </svg>
        </ng-container>
      </div>
      <div class="sv-toast-content">
        <span *ngIf="toast.title" class="sv-toast-title">{{ toast.title }}</span>
        <span *ngIf="toast.text" class="sv-toast-text">{{ toast.text }}</span>
      </div>
      <button class="sv-toast-close" (click)="closeToast($event, toast.id)">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round">
          <line x1="18" y1="6" x2="6" y2="18" />
          <line x1="6" y1="6" x2="18" y2="18" />
        </svg>
      </button>
      <!-- Barra de progresso -->
      <div class="sv-toast-progress" [style.animation-duration]="(toast.timer || 3000) + 'ms'"></div>
    </div>
  </ng-container>
</div>
